module.exports = __webpack_public_path__ + "static/media/goodleap-logo.d0f05cf9.svg";